module.exports = __webpack_public_path__ + "fonts/iconfont.b5a05ac4.ttf";